import {ProductEnum} from 'presentation/constants';

export const UNITS_CHANNELS_CONTACTS = {
	[ProductEnum.HAP]: {
		alert: 'Atendimento de segunda a sábado, das 6h às 21h',
		phones: [
			{
				title: 'Capital e Região Metropolitana',
				phones: ['4002-3633', '4020-3633'],
			},
			{
				title: 'Demais Localidades',
				phones: ['0300 313 3633'],
			},
		],
	},
	[ProductEnum.CCG]: {
		alert: 'Atendimento de segunda a sábado, das 6h às 21h',
		phones: [
			{
				title: 'Capital e Região Metropolitana',
				phones: ['(51) 2312-1505'],
			},
		],
	},
	[ProductEnum.CLINIPAM]: {
		alert: 'Atendimento de segunda a sábado, das 6h às 21h',
		phones: [
			{
				title: 'Capital e Região Metropolitana',
				phones: ['4090-2790'],
			},
			{
				title: 'Demais Localidades',
				phones: ['0800 800 2790'],
			},
		],
	},
	[ProductEnum.GNDI_MINAS]: {
		alert: 'Atendimento de segunda a sábado, das 6h às 21h',
		phones: [
			{
				title: 'Capital e Região Metropolitana',
				phones: ['4090-2290', '4090-2210'],
			},
			{
				title: 'Demais Localidades',
				phones: ['0800 800 2290'],
			},
		],
	},
	[ProductEnum.GNDI]: {
		alert: 'Atendimento de segunda a sábado, das 6h às 21h',
		phones: [
			{
				title: 'Capital e Região Metropolitana',
				phones: ['4090-1740'],
			},
			{
				title: 'Demais Localidades',
				phones: ['0800 409 1750'],
			},
		],
	},
	[ProductEnum.NOTREDAME_SAUDE]: {
		alert: 'Atendimento de segunda a sábado, das 6h às 21h',
		phones: [
			{
				title: 'Capital e Região Metropolitana',
				phones: ['4004-9057'],
			},
			{
				title: 'Demais Localidades',
				phones: ['0800 850 1157'],
			},
		],
	},
};
